<div class="box-content rd-widget client-intended-use-and-user-widget widget-{{widgetConfig.widgetId}} widgetNoTopBorder" *ngIf="widgetData">
  <div class="fullWidth">
    <div class="table-part">
      <table class="widget-flex" aria-hidden="true">
        <thead>
          <dynamic-growth-row [row]="1" [widget]="this">
            <tr>
              <td colspan="12"><widget-label [widget]="this" class="title" [color]="'red'" [fieldName]="'labelClientIntendedUseAndUser'" [align]="'left'"></widget-label></td>
            </tr>
          </dynamic-growth-row>
        </thead>
        <tbody>
          <dynamic-growth-row [row]="2" [widget]="this">
            <tr>
              <td><br /></td>
            </tr>
          </dynamic-growth-row>
          <dynamic-growth-row [row]="3" [widget]="this">
            <tr>
              <td colspan="6"><widget-value [align]="'left'" class="header">{{'clientIntendedUseAndUser.client' | rdTranslate}}</widget-value></td>
              <td colspan="6"><widget-value [align]="'left'" class="value">{{widgetData.client}}</widget-value></td>
            </tr>
          </dynamic-growth-row>
          <dynamic-growth-row [row]="4" [widget]="this">
            <tr>
              <td><br /></td>
            </tr>
          </dynamic-growth-row>
          <dynamic-growth-row [row]="5" [widget]="this">
            <tr>
              <td colspan="6"><widget-value [align]="'left'" class="header">{{'clientIntendedUseAndUser.intendedUse' | rdTranslate}}</widget-value></td>
              <td *ngIf="!editMode" colspan="6"><widget-value [align]="'left'" class="value">{{widgetData.intendedUse}}</widget-value></td>
              <td *ngIf="editMode" colspan="6"><input type="text" class="widget-input-text gridster-item-content" [(ngModel)]="widgetData.intendedUse" (ngModelChange)="setDirtyFlag(true)" /></td>
            </tr>
          </dynamic-growth-row>
          <dynamic-growth-row [row]="6" [widget]="this">
            <tr>
              <td><br /></td>
            </tr>
          </dynamic-growth-row>
          <dynamic-growth-row [row]="7" [widget]="this">
            <tr>
              <td colspan="6"><widget-value [align]="'left'" class="header">{{'clientIntendedUseAndUser.intendedUsers' | rdTranslate}}</widget-value></td>
              <td *ngIf="!editMode" colspan="6"><widget-value [align]="'left'" class="value">{{widgetData.intendedUsers}}</widget-value></td>
              <td *ngIf="editMode" colspan="6"><input type="text" class="widget-input-text gridster-item-content" [(ngModel)]="widgetData.intendedUsers" (ngModelChange)="setDirtyFlag(true)" /></td>
            </tr>
          </dynamic-growth-row>
        </tbody>
      </table>
    </div>
  </div>
</div>
